/* eslint-disable import/prefer-default-export */

import { Splash } from 'autogen/swagger/all';
import { type ISplash, splashesWithImagesTypesArray } from './types';

export function handleColor(color: string | undefined) {
    if (!color) return 'transparent';
    if (color.indexOf('#') === 0) return color;

    return `rgb(${color})`;
}

type ImageSplash = Pick<ISplash, 'type' | 'imageUrl' | 'size' | 'className'>;

export function filterSplashesByImage(arrayData?: ImageSplash[]): ImageSplash[] {
    if (!arrayData) return [];

    return arrayData.filter((splash: ImageSplash) => {
        // mimicking splashesWithImagesTypesArray.includes(splash.type);
        for (let i = 0; i < splashesWithImagesTypesArray.length; i++) {
            if (splash.type === splashesWithImagesTypesArray[i]) {
                return true;
            }
        }
        return false;
    });
}
